import React from 'react';
import { getBackgroundColor } from '../util/getColorClassName.tsx';
const Container = ({ children, bgColor, containerClasses, squareImage = null, squareContainerClasses = '', squareImageClasses = '' }) => {
    const containerBgColorClass = getBackgroundColor(bgColor);
    return (React.createElement("div", { className: `${containerBgColorClass} ${containerClasses}` },
        React.createElement("div", { className: `@container max-w-[1730px] mx-auto ${containerBgColorClass}` }, children),
        squareImage && (React.createElement("div", { className: `absolute ${squareContainerClasses}` },
            React.createElement("img", { src: squareImage, alt: "", className: squareImageClasses })))));
};
export default Container;
